<template>
  <div class="h-100">
    <div class="content-page p-3 pb-5 h-100">
      <div class="row">
        <div class="col-5">
          <b-button-group>
            <b-button
              class="bg-transparent border-0 hover-blue"
              @click="changeTab('leave')"
            >
              {{
                `${this.t.t(dictEnum.LBL_Leave)} (${
                  this.leaveApplicationList.length
                })`
              }}
              <span
                :class="{
                  bdr: true,
                  'bg-image-rainbow': this.tab === 'leave'
                }"
              ></span>
            </b-button>
            <b-button
              v-if="hasRight('AlwRead', Setting.MenuID.OutdoorWork)"
              class="bg-transparent border-0 hover-blue"
              @click="changeTab('outdoorwork')"
            >
              {{
                `${this.t.t(dictEnum.MENU_OutdoorWork)} (${
                  this.outdoorWorkList.length
                })`
              }}
              <span
                :class="{
                  bdr: true,
                  'bg-image-rainbow': this.tab == 'outdoorwork'
                }"
              ></span>
            </b-button>
            <b-button
              v-if="hasRight('AlwRead', Setting.MenuID.Candidates)"
              class="bg-transparent border-0 hover-blue"
              @click="changeTab('interviewSchedule')"
            >
              {{ this.t.t(dictEnum.LBL_Candidate) }}
              <span
                :class="{
                  bdr: true,
                  'bg-image-rainbow': this.tab == 'interviewSchedule'
                }"
              ></span>
            </b-button>
          </b-button-group>
        </div>
        <div class="col-7 text-right">
          <button
            type="button"
            class="approve btn btn-primary waves-effect waves-light"
            v-if="
              hasRight('AlwWrite', Setting.MenuID.Approval) &&
                tab != 'interviewSchedule'
            "
            :disabled="
              !menuRights.rightsForThisMenu.AlwWrite ||
                (checkboxlist.length == 0 && docCheckList.length == 0)
            "
            @click="approve"
          >
            {{ this.t.t(dictEnum.LBL_Approve) }}
          </button>
        </div>
      </div>
      <div class="row h-100">
        <div class="col-sm-12 h-100 pb-5">
          <div class="tab-content bg-white h-100">
            <div class="tab-pane active table-responsive color-table h-100">
              <div class="pa-3 d-flex align-items-center" v-if="tab == 'leave'">
                <div
                  v-for="(hint, index) in HintList"
                  :key="index"
                  class="pl-5 d-flex align-items-center"
                >
                  <div
                    :style="`background: ${hint.color};width:30px; height:10px`"
                  ></div>
                  <div>{{ hint.value }}</div>
                </div>
              </div>
              <div class="h-80" id="tableBody">
                <b-table
                  v-if="tab == 'leave'"
                  :items="displayList"
                  :fields="fieldsLeave.filter(x => x.show)"
                  :current-page="currentPage"
                  :per-page="leavePerPage"
                  :tbody-tr-class="rowClass"
                  thead-tr-class="tableHead"
                >
                  <template #cell(UserID)="data">
                    <p
                      :class="
                        `font-weight-bold ${
                          data.item.IsLateSubmit == true ? 'pink-color' : ''
                        }`
                      "
                    >
                      {{ data.item.UserName }}
                    </p>
                  </template>
                  <template #cell(DateAdd)="data">
                    <p
                      :class="
                        `font-weight-bold ${
                          data.item.IsLateSubmit == true ? 'pink-color' : ''
                        }`
                      "
                    >
                      {{
                        data.item.DateAdd
                          | moment(Setting.DateTime.yyyymmddhhmm)
                      }}
                    </p>
                  </template>
                  <template #cell(DateFrom)="data">
                    <p
                      :class="
                        `font-weight-bold ${
                          data.item.IsLateSubmit == true ? 'pink-color' : ''
                        }`
                      "
                    >
                      {{
                        data.item.DateFrom
                          | moment(Setting.DateTime.yyyymmddhhmm)
                      }}
                    </p>
                  </template>
                  <template #cell(DateTo)="data">
                    <p
                      :class="
                        `font-weight-bold ${
                          data.item.IsLateSubmit == true ? 'pink-color' : ''
                        }`
                      "
                    >
                      {{
                        data.item.DateTo | moment(Setting.DateTime.yyyymmddhhmm)
                      }}
                    </p>
                  </template>
                  <template #cell(DaysHrs)="data">
                    <div v-if="data.item.DaysHrs == 'h'">
                      <p
                        :class="
                          `font-weight-bold ${
                            data.item.IsLateSubmit == true ? 'pink-color' : ''
                          }`
                        "
                      >
                        {{ data.item.QtyDaysHrs }}
                        {{ t.t(dictEnum.LBL_Hours) }}
                      </p>
                    </div>
                    <div v-if="data.item.DaysHrs == 'hd'">
                      <p
                        :class="
                          `font-weight-bold ${
                            data.item.IsLateSubmit == true ? 'pink-color' : ''
                          }`
                        "
                      >
                        {{ data.item.QtyDaysHrs }}
                        {{ t.t(dictEnum.LBL_Hours) }}
                      </p>
                    </div>
                    <div v-if="data.item.DaysHrs == 'd'">
                      <p
                        :class="
                          `font-weight-bold ${
                            data.item.IsLateSubmit == true ? 'pink-color' : ''
                          }`
                        "
                      >
                        {{ data.item.QtyDaysHrs }}
                        {{ t.t(dictEnum.LBL_Days) }}
                      </p>
                    </div>
                  </template>

                  <template #cell(LeaveType)="data">
                    <p
                      :class="
                        `font-weight-bold ${
                          data.item.IsLateSubmit == true ? 'pink-color' : ''
                        }`
                      "
                    >
                      {{ data.item.LeaveDesc }}
                    </p>
                  </template>

                  <template #cell(LeaveBalBF)="data">
                    <p
                      v-if="
                        data.item.LeaveType == 'AL' ||
                          data.item.LeaveType == 'CL'
                      "
                      :class="
                        `font-weight-bold ${
                          data.item.IsLateSubmit == true ? 'pink-color' : ''
                        }`
                      "
                    >
                      {{ data.item.leaveBal.LeaveBalBF }}
                    </p>
                  </template>

                  <template #cell(LeaveBal)="data">
                    <p
                      v-if="data.item.LeaveType == 'AL'"
                      :class="
                        `font-weight-bold ${
                          data.item.IsLateSubmit == true ? 'pink-color' : ''
                        }`
                      "
                    >
                      {{ data.item.leaveBal.LeaveBal }}
                    </p>
                  </template>

                  <template #cell(LeaveBalCF)="data">
                    <p
                      v-if="data.item.LeaveType == Setting.LeaveType.AL"
                      :class="
                        `font-weight-bold ${
                          data.item.IsLateSubmit == true ? 'pink-color' : ''
                        }`
                      "
                    >
                      {{
                        showLeaveBal
                          ? data.item.leaveBal.LeaveBalCF
                          : data.item.leaveBal.LeaveBalBF
                      }}
                    </p>
                    <p
                      v-if="data.item.LeaveType == Setting.LeaveType.CL"
                      :class="
                        `font-weight-bold ${
                          data.item.IsLateSubmit == true ? 'pink-color' : ''
                        }`
                      "
                    >
                      {{ data.item.LeaveBalance }}
                    </p>
                  </template>

                  <template #cell(Remark)="data">
                    <p
                      :class="
                        `font-weight-bold ${
                          data.item.IsLateSubmit == true ? 'pink-color' : ''
                        }`
                      "
                    >
                      {{ data.item.Remark }}
                    </p>
                  </template>

                  <template #cell(CancelReason)="data">
                    <p
                      :class="
                        `font-weight-bold ${
                          data.item.IsLateSubmit == true ? 'pink-color' : ''
                        }`
                      "
                    >
                      {{ data.item.CancelReason }}
                    </p>
                  </template>

                  <template #cell(LeaveApproved)="data">
                    <div
                      style="text-align:center"
                      v-if="
                        data.item.Approved == '' ||
                          data.item.Approved == null ||
                          data.item.Approved ==
                            Setting.LeaveStatus.CancelLeavePending
                      "
                    >
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="`chkBox${data.item.TxNum}`"
                          v-model="checkboxlist"
                          :v-id="data.item.TxNum"
                          :value="data.item.TxNum"
                        />
                        <label
                          class="custom-control-label text-white"
                          :for="`chkBox${data.item.TxNum}`"
                        ></label>
                      </div>
                    </div>
                  </template>

                  <template #cell(DocApproved)="data">
                    <div
                      v-if="needUploadFile(data.item)"
                      style="text-align:center"
                    >
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          v-model="docCheckList"
                          :id="`doc${data.item.TxNum}`"
                          :v-id="data.item.TxNum"
                          :value="data.item.TxNum"
                        />
                        <label
                          class="custom-control-label text-white"
                          :for="`doc${data.item.TxNum}`"
                        ></label>
                      </div>
                    </div>
                  </template>

                  <template #cell(Action)="data">
                    <div class="float-right">
                      <a
                        @click="assignRejectObj(data.item)"
                        href="#"
                        v-b-modal.modal-reject
                        class="text-danger"
                      >
                        {{ t.t(dictEnum.LBL_Reject) }}
                      </a>
                      <a
                        v-if="data.item.HaveAttachments"
                        href="javascript:void(0);"
                        class="pl-2"
                        v-on:click="onClickViewAttachment(data.item)"
                      >
                        <img src="../../static/images/eye.png" class="w-14" />
                      </a>
                    </div>
                  </template>
                </b-table>
                <b-table
                  v-if="tab == 'outdoorwork'"
                  :items="displayList"
                  :fields="fieldsOutdoor"
                  :current-page="currentPage"
                  :per-page="10"
                  :tbody-tr-class="rowClass"
                >
                  <template #cell(UserID)="data">
                    <p>
                      {{ data.item.UserName }}
                    </p>
                  </template>
                  <template #cell(Approved)="data">
                    <div v-if="!data.item.Approved">
                      <div class="row">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="`chkBox${data.item.UniqueID}`"
                            v-model="checkboxlist"
                            :v-id="data.item.UniqueID"
                            :value="data.item.UniqueID"
                          />
                          <label
                            class="custom-control-label text-white"
                            :for="`chkBox${data.item.UniqueID}`"
                          ></label>
                        </div>
                        <a
                          href="#"
                          @click="assignRejectObj(data.item)"
                          v-b-modal.modal-reject
                          class="text-danger"
                          style="color: red"
                          >{{ t.t(dictEnum.LBL_Reject) }}</a
                        >
                      </div>
                    </div>
                  </template>
                  <template #cell(AddrIn)="data">
                    <div style="word-wrap: break-word">
                      {{ data.item.AddrIn }}
                    </div>
                  </template>
                  <template #cell(AddrOut)="data">
                    <div style="word-wrap: break-word">
                      {{ data.item.AddrOut }}
                    </div>
                  </template>
                  <template #cell(ExtIn)="data">
                    <div v-if="data.item.ExtIn">
                      {{ data.item.ExtIn | momentTime("HH:mm") }}
                    </div>
                  </template>
                  <template #cell(ExtOut)="data">
                    <div v-if="data.item.ExtOut">
                      {{ data.item.ExtOut | momentTime("HH:mm") }}
                    </div>
                  </template>
                  <template #cell(TimeIn)="data">
                    <div v-if="data.item.TimeIn">
                      {{
                        data.item.TimeIn | moment(Setting.DateTime.yyyymmddhhmm)
                      }}
                    </div>
                  </template>
                  <template #cell(TimeOut)="data">
                    <div v-if="data.item.TimeOut">
                      {{
                        data.item.TimeOut
                          | moment(Setting.DateTime.yyyymmddhhmm)
                      }}
                    </div>
                  </template>
                </b-table>
                <interviewSchedule
                  v-if="this.tab === 'interviewSchedule'"
                  ref="refInterviewSchedule"
                >
                </interviewSchedule>
              </div>

              <b-row
                no-gutters
                class="pt-3"
                v-if="this.tab != 'interviewSchedule'"
              >
                <b-col cols="2">
                  <b-pagination
                    first-number
                    last-number
                    limit="10"
                    v-model="currentPage"
                    :per-page="leavePerPage"
                    :total-rows="displayList.length"
                  ></b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-reject"
      :title="t.t(dictEnum.LBL_Reject)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="reject"
      @hide="cancelReject"
    >
      <div class="d-block text-center">
        <div class="form-group p-3">
          <textarea
            v-model="rejectReason"
            :placeholder="t.t(dictEnum.CFM_Reject)"
            class="form-control"
            rows="9"
            cols="3"
            maxlength="100"
          ></textarea>
        </div>
      </div>
      <b-row
        no-gutters
        v-if="
          tab == 'leave' &&
            rejectedObj.IsNeedUpload &&
            (rejectedObj.Approved == Setting.LeaveStatus.Approved ||
              rejectedObj.Approved ==
                Setting.LeaveStatus.CancelledLeaveRejected)
        "
      >
        <b-form-group class="pl-3">
          <b-form-checkbox v-model="checkIfRejectLeave">
            {{ t.t(dictEnum.MSG_ConfirmUpdateLeave) }}
          </b-form-checkbox>
        </b-form-group>
      </b-row>
      <b-row
        no-gutters
        v-if="tab == 'leave' && rejectedObj.IsNeedUpload && checkIfRejectLeave"
      >
        <b-form-group class="pl-3 pr-3 w-100">
          <b-form-select
            v-model="rejectLeaveType"
            :options="leaveTypeList"
            value-field="LeaveType"
            :text-field="user.Lang == 'EN' ? 'EDesc' : 'CDesc'"
          ></b-form-select>
        </b-form-group>
      </b-row>
    </b-modal>

    <b-modal
      id="modal-viewAttachment"
      hide-footer
      :title="t.t(dictEnum.LBL_Attachment)"
    >
      <div class="p-2">
        <div class="row xs-gutters">
          <div
            v-for="(item, index) in selectedLeaveApp.AttachmentList"
            :key="index"
          >
            <span v-if="!item.IsDeleted" class="d-none">
              {{ (item.DocID = index + 1) }}
            </span>
            <div
              class="col-6"
              v-if="item.DocURL != null && item.DocURL != '' && !item.IsDeleted"
            >
              <!-- <button
                type="button"
                class="btn btn-transparent py-0 pl-1 pr-0 mr-2"
                v-b-modal.deleteAttachmentModal
                v-on:click="deleteAttachmentPopup(item)"
              >
                <img src="../../static/images/cancel-gray.png" class="w-10" />
              </button> -->
              <div
                v-viewer
                v-if="
                  item.DocMime.indexOf('image/') > -1 &&
                    item.DocURL != null &&
                    item.DocURL != ''
                "
              >
                <img :src="item.DocURL" class="w-50" />
              </div>
              <a
                v-if="
                  item.DocMime.indexOf('image/') == -1 &&
                    item.DocURL != null &&
                    item.DocURL != ''
                "
                download
                :href="item.DocURL"
              >
                <img src="../../static/images/document.png" class="w-20"
              /></a>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <!--
    <b-modal
      id="modal-approve"
      :title="t.t(dictEnum.LBL_Approve)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="approve"
    >
      <div
        class="d-flex flex-column text-center justify-content-center align-items-center"
      >
        <font-awesome-icon
          class="mb-5"
          :icon="['fas', 'question-circle']"
          size="9x"
          :style="{ color: 'grey' }"
        />
        {{ `${t.t(dictEnum.CFM_Approve)}?(${this.checkboxlist.length})` }}
      </div>
    </b-modal>-->
  </div>
</template>

<script>
import moment from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import ApprovalService from "@/service/ApprovalService";
import UserService from "@/service/UserService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import t from "@/service/SysMsgService";
import StoreGetter from "@/constants/StoreGetter";
import interviewSchedule from "./S110000-InterviewSchedule/S110000-InterviewSchedule.vue";
import Setting from "@/constants/Settings";
import LeaveTypeService from "@/service/LeaveTypeService";
import { api as viewerApi } from "v-viewer";
export default {
  components: { interviewSchedule },
  data() {
    return {
      Setting: Setting,
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Setting.MenuID.Approval,
      checkboxlist: [],
      leaveApplicationList: [],
      outdoorWorkList: [],
      tab: "leave",
      rejectReason: "",
      checkIfRejectLeave: false,
      rejectLeaveType: "",
      dictEnum: dictEnum,
      selectedLeaveApp: {},
      HintList: [],
      docCheckList: [],
      leaveTypeList: [],
      rejectedObj: {},
      currentPage: 1,
      fieldsLeave: [
        {
          key: "UserID",
          label: t.t(dictEnum.LBL_Staff),
          show: true
        },
        {
          key: "DateAdd",
          label: t.t(dictEnum.LBL_DateApply),
          show: true
        },
        {
          key: "DateFrom",
          label: t.t(dictEnum.LBL_From),
          show: true
        },
        {
          key: "DateTo",
          label: t.t(dictEnum.LBL_To),
          show: true
        },
        {
          key: "DateFrom",
          label: t.t(dictEnum.LBL_From),
          show: true
        },
        {
          key: "DaysHrs",
          label: t.t(dictEnum.LBL_Duration),
          show: true
        },
        {
          key: "LeaveType",
          label: t.t(dictEnum.MENU_LeaveType),
          show: true
        },
        {
          key: "LeaveBalBF",
          label: t.t(dictEnum.LBL_Cumulation),
          show: true
        },
        {
          key: "LeaveBal",
          label: t.t(dictEnum.LBL_Leavebalasoftoday),
          show: true
        },
        {
          key: "LeaveBalCF",
          label: t.t(dictEnum.LBL_Balance),
          show: true
        },
        {
          key: "Remark",
          label: t.t(dictEnum.LBL_LeaveReason),
          show: true
        },
        {
          key: "CancelReason",
          label: t.t(dictEnum.LBL_CancelReason),
          show: true
        },
        {
          key: "LeaveApproved",
          label: t.t(dictEnum.LBL_Leave),
          show: true
        },
        {
          key: "DocApproved",
          label: t.t(dictEnum.LBL_Attachment),
          show: true
        },
        {
          key: "reject",
          label: "",
          show: true
        },
        {
          key: "Action",
          label: "",
          show: true
        }
      ],
      leavePerPage: 10,
      fieldsOutdoor: [
        {
          key: "UserID",
          label: t.t(dictEnum.LBL_Staff)
        },
        {
          key: "DateWork",
          label: t.t(dictEnum.LBL_Date)
        },
        {
          key: "EventTitle",
          label: t.t(dictEnum.LBL_Event)
        },
        {
          key: "ExtIn",
          label: t.t(dictEnum.LBL_ExpectedInAbbr)
        },
        {
          key: "TimeIn",
          label: t.t(dictEnum.LBL_ActInAbbr)
        },
        {
          key: "AddrIn",
          label: t.t(dictEnum.LBL_AddrIn)
        },
        {
          key: "ExtOut",
          label: t.t(dictEnum.LBL_ExpectedOutAbbr)
        },
        {
          key: "TimeOut",
          label: t.t(dictEnum.LBL_ActOutAbbr)
        },
        {
          key: "AddrOut",
          label: t.t(dictEnum.LBL_AddrOut)
        },
        {
          key: "WorkingHours",
          label: t.t(dictEnum.LBL_WorkHrs)
        },
        {
          key: "Allowance",
          label: t.t(dictEnum.LBL_Allowance)
        },
        {
          key: "Approved",
          label: t.t(dictEnum.LBL_Approve)
        }
      ]
    };
  },
  computed: {
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    t() {
      return t;
    },
    displayList() {
      if (this.tab == "leave") {
        return this.leaveApplicationList;
      } else if (this.tab == "outdoorwork") {
        return this.outdoorWorkList;
      }
    },
    columns() {
      const leaveAppColumns = [
        "UserID",
        "DateAdd",
        "DateFrom",
        "DateTo",
        "DaysHrs",
        "LeaveType",
        "Balance",
        "Remark",
        "CancelReason",
        "LeaveApproved",
        "DocApproved",
        "Action"
      ];
      const outdoorworkColumns = [
        "UserID",
        "DateWork",
        "EventTitle",
        "ExtIn",
        "TimeIn",
        "AddrIn",
        "ExtOut",
        "TimeOut",
        "AddrOut",
        "WorkingHours",
        "Allowance",
        "Approved"
      ];
      return this.tab == "leave" ? leaveAppColumns : outdoorworkColumns;
    },
    showLeaveBal() {
      const find = this.$store.state.SysParamsStore.sysParams.find(
        x => x.ParamCode == Setting.SysParams.ShowLvBalance
      );
      if (find) {
        return find.ParamVal.toLowerCase() == "true";
      }
    },
    options() {
      const leaveAppClasses = {
        UserID: "w-10",
        DateAdd: "w-10",
        DateFrom: "w-10",
        DateTo: "w-10",
        DaysHrs: "w-5",
        LeaveType: "w-10",
        Balance: "w-10",
        Remark: "w-10",
        LeaveApproved: "w-5",
        DocApproved: "w-5",
        CancelReason: "w-10",
        reject: "w-10",
        Action: "w-10"
      };
      const outdoorWorkClasses = {
        UserID: "w-10Per",
        DateWork: "w-10Per",
        EventTitle: "w-10Per",
        ExtIn: "w-10Per",
        TimeIn: "w-10Per",
        AddrIn: "w-10Per",
        ExtOut: "w-10Per",
        TimeOut: "w-6Per",
        AddrOut: "w-14Per",
        WorkingHours: "w-10Per",
        Allowance: "w-10Per",
        Approved: "w-4Per"
      };

      const leaveAppTableHeading = {
        UserID: this.t.t(dictEnum.LBL_Staff),
        DateAdd: this.t.t(dictEnum.LBL_DateAdded),
        DateFrom: this.t.t(dictEnum.LBL_From),
        DateTo: this.t.t(dictEnum.LBL_To),
        DaysHrs: this.t.t(dictEnum.LBL_Duration),
        LeaveType: this.t.t(dictEnum.MENU_LeaveType),
        Balance: this.t.t(dictEnum.LBL_Balance),
        Remark: this.t.t(dictEnum.LBL_LeaveReason),
        LeaveApproved: this.t.t(dictEnum.LBL_Leave),
        DocApproved: this.t.t(dictEnum.LBL_Attachment),
        CancelReason: this.t.t(dictEnum.LBL_CancelReason),
        reject: "",
        Action: ""
      };
      const outdoorworkHeading = {
        UserID: this.t.t(dictEnum.LBL_Staff),
        DateWork: this.t.t(dictEnum.LBL_Date),
        EventTitle: this.t.t(dictEnum.LBL_Event),
        ExtIn: this.t.t(dictEnum.LBL_ExpectedInAbbr),
        TimeIn: this.t.t(dictEnum.LBL_ActInAbbr),
        AddrIn: this.t.t(dictEnum.LBL_AddrIn),
        ExtOut: this.t.t(dictEnum.LBL_ExpectedOutAbbr),
        TimeOut: this.t.t(dictEnum.LBL_ActOutAbbr),
        AddrOut: this.t.t(dictEnum.LBL_AddrOut),
        WorkingHours: this.t.t(dictEnum.LBL_WorkHrs),
        Allowance: this.t.t(dictEnum.LBL_Allowance),
        Approved: this.t.t(dictEnum.LBL_Approve)
      };
      const opt = {
        filterable: false,
        sortable: [],
        perPageValues: [],
        skin: "table table-hover v-midle",
        headings:
          this.tab == "leave" ? leaveAppTableHeading : outdoorworkHeading,
        texts: {
          noResults: this.t.t(dictEnum.LBL_NoData),
          count: ``
        },
        columnsClasses:
          this.tab == "leave" ? leaveAppClasses : outdoorWorkClasses,
        rowClassCallback: function(row) {
          let colorClass = "";
          if (row.Approved == Setting.LeaveStatus.CancelLeavePending)
            colorClass = "bg-cancelled";
          return colorClass;
        }
      };
      return opt;
    }
  },
  filters: {
    momentTime: function(date, format) {
      if (date) {
        return moment(date, "HH:mm:ss").format(format);
      } else {
        return undefined;
      }
    }
  },
  methods: {
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRejectObj(data) {
      this.rejectedObj = data;
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    changeTab(tabName) {
      this.tab = tabName;
      this.checkboxlist = [];
    },

    async getPerPage() {
      let perPage = 10;
      const tableEle = await document.getElementById("tableBody");
      const headEle = await document.getElementsByClassName("tableHead");
      const trEle = await document.getElementsByClassName("tableTr");
      if (trEle.length > 0) {
        const tableHeight = tableEle.offsetHeight;
        const headHeight = headEle[0].offsetHeight;
        const trHeight = trEle[0].offsetHeight;
        perPage = (tableHeight - headHeight * 2) / trHeight;
        this.leavePerPage = perPage.toFixed(0);
      }
    },

    async getLeaveType() {
      const response = await LeaveTypeService.getLeaveTypes();
      if (!response.data.IsSuccess) {
        SweetAlertService.warning("Warn", response.data.Message);
      } else {
        this.leaveTypeList = response.data.Data;
      }
    },

    rowClass(item, type) {
      let colorClass = "tableTr";
      if (!item || type !== "row") return;
      if (item.Approved == Setting.LeaveStatus.CancelLeavePending) {
        colorClass = "bg-cancelled";
      }
      return colorClass;
    },

    needUploadFile(item) {
      if (
        item.HaveAttachments &&
        item.IsNeedUpload &&
        (item.DocStatus == "" || item.DocStatus == null)
      ) {
        return true;
      } else {
        return false;
      }
    },

    getSelectedOutdoorworkArray() {
      const selectedOutdoororks = [];
      this.checkboxlist.forEach(x => {
        const outdoorwork = this.outdoorWorkList.find(y => y.UniqueID === x);
        if (outdoorwork) {
          selectedOutdoororks.push({
            UserID: outdoorwork.UserID,
            EventCode: outdoorwork.EventCode,
            DateWork: outdoorwork.DateWork,
            WorkingHours: outdoorwork.WorkingHours
          });
        }
      });
      return selectedOutdoororks;
    },
    resetSelectedChkBox() {
      this.checkboxlist = [];
      this.docCheckList = [];
      this.rejectLeaveType = "";
      this.checkIfRejectLeave = false;
    },
    async approve() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.CFM_Approve)}?(${this.checkboxlist.length})`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        if (this.tab === "outdoorwork") {
          const outdookWorkList = this.getSelectedOutdoorworkArray();
          const requestObj = {
            eventApprovalReq: outdookWorkList,
            supervisorId: this.supervisorId
          };

          const response = await ApprovalService.approveOutdoorwork(requestObj);
          if (!response.data.IsSuccess) {
            SweetAlertService.warning("Warn", response.data.Message);
          } else {
            SweetAlertService.success("Success", response.data.Message);
            this.resetSelectedChkBox();
            this.getoutdoorwork();
          }
        } else if (this.tab === "leave") {
          let list = this.checkboxlist;
          this.docCheckList.forEach(x => {
            const find = this.displayList.find(item => item.TxNum == x);
            if (!list.includes(x) && this.needUploadFile(find)) {
              list.push(x);
            }
          });

          const requestObj = {
            txNum: list,
            docNum: this.docCheckList,
            supervisorId: this.supervisorId
          };

          this.isLoading = true;

          const response = await ApprovalService.approveLeave(requestObj);
          if (!response.data.IsSuccess) {
            SweetAlertService.warning("Warn", response.data.Message);
          } else {
            SweetAlertService.success("Success", response.data.Message);
            this.resetSelectedChkBox();
            this.getdatatable();
          }
        }
      }
    },

    async getdatatable() {
      var self = this;
      const obj = {
        userId: this.$store.getters[StoreGetter.user].UserID,
        inclSubordinate: 1
      };

      const response = await ApprovalService.getLeave(obj);

      if (!response.data.IsSuccess) {
        SweetAlertService.warning("Warn", response.data.Message);
      } else {
        self.leaveApplicationList = response.data.Data;
        this.getPerPage();
      }
    },
    async getoutdoorwork() {
      var self = this;
      const obj = {
        userId: this.$store.getters[StoreGetter.user].UserID
      };

      const response = await ApprovalService.getOutdoorkwork(obj);
      if (!response.data.IsSuccess) {
        self.$alertify.error(response.data.Message);
      } else {
        self.outdoorWorkList = response.data.Data;
        this.resetSelectedChkBox();
      }
    },

    async reject() {
      if (!this.rejectReason) {
        SweetAlertService.warning("Warn", this.t.t(dictEnum.CFM_Reject));

        this.rejectReason = "";
        return;
      }

      if (this.tab == "leave") {
        let txNum = "",
          docNum = "";
        if (
          !this.checkboxlist.includes(this.rejectedObj.TxNum) &&
          !this.docCheckList.includes(this.rejectedObj.TxNum) &&
          !this.checkIfRejectLeave
        ) {
          this.rejectReason = "";
          return;
        }

        if (this.rejectLeaveType == this.rejectedObj.LeaveType) {
          SweetAlertService.warning(
            "Warn",
            this.t.t(dictEnum.MSG_CantChangeToSameLeaveType)
          );
          return;
        }

        if (this.checkIfRejectLeave) {
          docNum = this.rejectedObj.TxNum;
          txNum = this.rejectedObj.TxNum;
        }

        if (this.checkboxlist.includes(this.rejectedObj.TxNum)) {
          txNum = this.rejectedObj.TxNum;
        }

        if (
          this.checkboxlist.includes(this.rejectedObj.TxNum) &&
          this.rejectedObj.HaveAttachments &&
          this.rejectedObj.Approved == null
        ) {
          docNum = this.rejectedObj.TxNum;
        }

        if (this.docCheckList.includes(this.rejectedObj.TxNum)) {
          docNum = this.rejectedObj.TxNum;
        }

        const obj = {
          txNum: txNum,
          docNum: docNum,
          userId: this.$store.getters[StoreGetter.user].UserID,
          rejReason: this.rejectReason,
          supervisorId: this.$store.getters[StoreGetter.user].UserID,
          leaveType: this.rejectLeaveType
        };
        const response = await ApprovalService.rejectLeave(obj);
        if (response.data.IsSuccess) {
          this.cancelReject();
          SweetAlertService.success("Success", response.data.Message);
          this.resetSelectedChkBox();
          this.getdatatable();
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      } else {
        const obj = {
          userId: this.rejectedObj.UserID,
          eventCode: this.rejectedObj.EventCode,
          dateWork: moment(this.rejectedObj.DateWork).format(
            Setting.DateTime.yyyymmddhhmm
          ),
          rejReason: this.rejectReason,
          supervisorId: this.$store.getters[StoreGetter.user].UserID
        };

        const response = await ApprovalService.rejectOutdoorwork(obj);
        if (!response.data.IsSuccess) {
          SweetAlertService.warning("Warn", response.data.Message);
        } else {
          this.resetSelectedChkBox();
          SweetAlertService.success("Success", response.data.Message);
          this.getoutdoorwork();
        }
      }

      this.rejectReason = "";
    },

    cancelReject() {
      this.checkIfRejectLeave = false;
      this.rejectLeaveType = "";
      this.rejectReason = "";
    },

    async onClickViewAttachment(row) {
      this.selectedLeaveApp = row;
      const obj = {
        txNum: this.selectedLeaveApp.TxNum,
        compCode: ""
      };
      const response = await UserService.getLeaveAttachments(obj);
      if (!response.data.IsSuccess) {
        SweetAlertService.warning("Warn", response.data.Message);
      } else {
        this.selectedLeaveApp.AttachmentList = response.data.Data;
        this.$bvModal.show("modal-viewAttachment");
      }
    },

    clickImageShow(AttachmentList) {
      const images = AttachmentList.filter(item => {
        item.DocMime.indexOf("image/") > -1 &&
          item.DocURL != null &&
          item.DocURL != "";
      }).map(x => x.DocURL);
      const $viewer = viewerApi({
        options: {
          toolbar: true,
          url: "data-source",
          initialViewIndex: 1
        },
        images: images
      });
    },

    getHint() {
      let data = 0;
      let appNotMoreString = "";
      const find = this.$store.state.SysParamsStore.sysParams.find(
        x => x.ParamCode == Setting.SysParams.LateSubmit
      );
      if (find) {
        data = Number(find.ParamVal);
        appNotMoreString = t.t(dictEnum.LBL_LateSubmit).replace("#", data);
      }
      this.HintList = [
        {
          id: "AppCancelled",
          color: "#ddd",
          value: `${t.t(dictEnum.LBL_CancelLeaveApplication)}`
        },
        {
          id: "AppNotMore",
          color: "#e23e9b",
          value: appNotMoreString
        }
      ];
    }
  },

  mounted() {
    this.assignRights();
    this.isLoading = true;
    var data = this.$store.getters[StoreGetter.user];
    this.supervisorId = data.UserID;
    this.token = data.AccessToken;
    this.getdatatable();
    this.getoutdoorwork();
    this.getLeaveType();
    this.getHint();
    var self = this;
    this.fieldsLeave.forEach(fl => {
      if (fl.key === "LeaveBalBF") {
        fl.show = self.showLeaveBal;
      } else if (fl.key === "LeaveBal") {
        fl.show = self.showLeaveBal;
      }
    });
  }
};
</script>

<style scoped>
.hover-blue:hover {
  color: #3292e0;
}

.hover-blue:focus {
  color: #3292e0;
}

.w-4Per {
  width: 4% !important;
}

.w-6Per {
  width: 6% !important;
}

.w-8Per {
  width: 8% !important;
}

.w-10Per {
  width: 10% !important;
}

.w-14Per {
  width: 14% !important;
}

.w-15Per {
  width: 15% !important;
}

.w-20Per {
  width: 30% !important;
}

.w-30Per {
  width: 30% !important;
}

tbody {
  background-color: white;
  overflow: auto;
}

.pink-color {
  color: #e23e9b;
}
</style>



// WEBPACK FOOTER //
// src/components/S010000-Approval.vue